<ng-container *ngLet="showBannerOnly$ | async as showBannerOnly">
	<header>
		<div class="w-100 container-title">
			<div class="container">
				<div class="row">
					<div class="col-10">
						<a [routerLink]="getRouterLink(ROUTE_PATH.ROOT)">
							<app-logo></app-logo>
						</a>
					</div>
					<div class="col-2 position-relative">
						<app-language-switcher></app-language-switcher>
					</div>
				</div>
			</div>
		</div>
		<app-current-status-events></app-current-status-events>
		<div class="w-100 container-menu" *ngIf="showBannerOnly">
			<div class="container h-100">
				<nav
					class="navbar navbar-expand-lg navbar-light justify-content-end justify-content-lg-start"
				>
					<button
						class="navbar-toggler"
						type="button"
						(click)="navbarCollapsed = !navbarCollapsed"
					>
						<span class="navbar-toggler-icon"></span>
					</button>
					<div class="collapse navbar-collapse" [ngbCollapse]="navbarCollapsed">
						<ul class="navbar-nav mr-auto">
							<li class="nav-item">
								<a
									class="nav-link"
									[routerLink]="getRouterLink(ROUTE_PATH.APPLICATION)"
									routerLinkActive="active"
								>
									<span translate>Clausius App</span>
								</a>
							</li>
							<li class="nav-item">
								<a
									class="nav-link"
									[routerLink]="getRouterLink(ROUTE_PATH.HOW_IT_WORKS)"
									routerLinkActive="active"
								>
									<span translate>How it works</span>
								</a>
							</li>
							<li class="nav-item">
								<a
									class="nav-link"
									[routerLink]="getRouterLink(ROUTE_PATH.OFFER)"
									routerLinkActive="active"
								>
									<span translate>Offer</span>
								</a>
							</li>
							<li class="nav-item">
								<a
									class="nav-link"
									[routerLink]="getRouterLink(ROUTE_PATH.PARTNERS)"
									routerLinkActive="active"
								>
									<span translate>Become a partner</span>
								</a>
							</li>
							<li class="nav-item">
								<a
									class="nav-link"
									[routerLink]="getRouterLink(ROUTE_PATH.CONTACT)"
									routerLinkActive="active"
								>
									<span translate>Contact and support</span>
								</a>
							</li>
							<li class="nav-item">
								<a
									class="nav-link"
									href="https://betterstatus.seltronhome.com/"
									target="_blank"
								>
									<span translate>Service status</span>
								</a>
							</li>
						</ul>
					</div>
				</nav>
			</div>
		</div>
	</header>
</ng-container>
